// Constants and utility functions

export const getAgentName = (agentId) => {
  const agentNames = {
    3: 'Bill Processing Agent',
    12: 'Sales Order Agent',
    13: 'Bank Statement Agent',
    // Add more as needed
  };
  return agentNames[agentId] || `Agent ${agentId}`;
};
